var render = function (_h,_vm) {var _c=_vm._c;return _c('p',{class:[
  'fst-italic text-muted',
  _vm.data.class,
  _vm.data.staticClass
]},[_c('span',{staticClass:"bi bi-exclamation-circle"}),_vm._v(" Complete the form below to proceed. Fields with an asterisk (*) are required. ")])}
var staticRenderFns = []

export { render, staticRenderFns }